import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import projectStyles from '../../styles/Projects.module.css'
import { Heart, HeartFill } from "react-bootstrap-icons"
import RegisterModal from "../User/RegisterModal"
import { useState } from "react"

export default function ProjectDownHeart(props) {
    // const [likeCount, setLikeCount] = useState(props.votes)
    // const [like, setLike] = useState(props.like)
    // replace the useState(true) below with user liked the project boolean from db
    // const handler = (e, bool, projectId) => {
    //     bool ? setLike(true) : setLike(false)
    //     props.handleLikes(e, bool, projectId)
    // }
    return (
        <Row>
            <Col className="my-auto">
                <p className={projectStyles.downloads}>{props.downloads} Downloads</p>
            </Col>
            <Col className="my-auto text-end">
                <p className={projectStyles.likes}>{props.votes}
                {props.user ? 
                        props.like ? 
                                <Button variant="link" onClick={(e) => props.handleLikes(e, false, props.id, props.profileId)}>
                                    <HeartFill className={projectStyles.heart} />
                                </Button>
                                :
                                <Button variant="link" onClick={(e) => props.handleLikes(e, true, props.id, props.profileId)}>
                                    <Heart className={projectStyles.heart} />
                                </Button>
                : 
                            //add on click show the register modal
                            <Button variant="link" onClick={() => props.setRegisterModal(true)}>
                                <Heart className={projectStyles.heart} />
                            </Button>  
                }
               
                </p>
            </Col>
        </Row>
        
    )
}